import React from "react";
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";

const MyGridItem = styled(({ minHeight, ...other }) => <Grid {...other} />)`
  && {
    min-height: ${props => (props.minHeight ? props.minHeight : "84")}px;
  }
`;

export default MyGridItem;
